import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import http from "@core/fetch";
import { IFoodProfileSummary } from "@models/NewFoodProfileSummary";
import { addFileToPackage } from "@actions/packages.actions";

/** Download-report and add-to-package actions for a food profile. */
export default function useFoodProfileReportActions(id: IFoodProfileSummary["id"], downloadLink: string) {
    const dispatch = useDispatch();
    const [isDownloading, setIsDownloading] = useState(false);

    const download = useCallback(async () => {
        if (!downloadLink) return;
        setIsDownloading(true);
        try {
            await http.downloadFileXHRFromUrl('GET', downloadLink);
            toast.success('Report downloaded successfully');
        } catch {
            toast.error('Failed to download report');
        } finally {
            setIsDownloading(false);
        }
    }, [downloadLink]);

    const addToPackage = useCallback(() => {
        if (id === null || id === undefined) return;
        toast.success('Item has been added to package');
        dispatch(addFileToPackage({ itemId: id, itemDocumentType: 'foodProfile' }));
    }, [dispatch, id]);

    return { download, addToPackage, isDownloading };
}
